<template>
  <div class="Frame">

    <div class="Frame__deco" :class="['is-' + type]">
      <div class="Frame__bar is-vertical is-left" />
      <div class="Frame__bar is-vertical is-right" />
      <div class="Frame__bar is-horizontal is-top" />
      <div class="Frame__bar is-horizontal is-bottom" />

      <div class="Frame__mosaic" :class="name" v-for="name in mosaic[type]">
        <div class="Frame__mosaic-box is-top-left" />
        <div class="Frame__mosaic-box is-top-right" />
        <div class="Frame__mosaic-box is-bottom-left" />
      </div>
    </div>

    <div class="Frame__top-right">
      <div v-if="type == 'lang' || type == 'map'" class="Frame__lang" @click="$root.langSwitch()">{{ lang == 'fr' ? 'en' : 'fr' }}</div>
      <div @click="close" class="Frame__close" v-if="type == 'capture' || type == 'code' || type == 'share_marker'">
        <img :src="require('@/commons/img/close.png')" />
      </div>
    </div>

    <div class="Frame__top-left">
      <div @click="$parent.image = null" v-if="type == 'share_selfie' || type == 'share_marker'">
        <img :src="require('./img/back.png')" />
      </div>
    </div>

    <div class="Frame__bottom-right">
      <div @click="btnSwitchMode" v-if="type == 'capture'">
        <img :src="require('./img/selfie.png')" />
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'Frame',
  props: ['type'],
  data: () => ({
    mosaic: {
      lang: ['is-top-left', 'is-bottom-left', 'is-bottom-right'],
      map: ['is-top-left', 'is-bottom-left', 'is-bottom-right'],
      capture: ['is-top-left', 'is-bottom-left'],
      share_selfie: ['is-bottom-left', 'is-bottom-right', 'is-top-right'],
      share_marker: ['is-bottom-left', 'is-bottom-right'],
      code: ['is-bottom-left', 'is-bottom-right', 'is-top-left'],
    },
    btn: {
      lang: ['is-top-right'],
      map: ['is-top-right'],
      capture: ['is-top-right', 'is-bottom-right'],
      share_selfie: ['is-top-left'],
      share_marker: ['is-top-left', 'is-top-right'],
      code: ['is-top-right'],
    }
  }),
  computed: {
    route() { return this.$store.getters['app/route'] }
  },
  methods: {
    close() {
      if(this.type == 'share_marker')
        this.$parent.image = null

      this.$router.push({ name: 'map.' + this.lang })
    },
    btnSwitchMode() {
      if(this.$route.meta.name == 'marker')
        return this.$router.push({ name: 'selfie.' + this.lang })

      if(this.$route.meta.name == 'selfie') {
        if(this.route.from.meta.name == 'marker')
          return this.$router.push({ name: 'marker.' + this.lang, params: { marker: this.route.from.params.marker } })

        return this.$router.push({ name: 'map.' + this.lang })
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Frame

  &__lang
    font-size 14px
    position relative
    &:before
      content ' '
      position absolute
      height 1px
      background white
      left 0px
      bottom 4px
      left 2px
      right 2px

  &__close
    display block

  &__deco
    position absolute
    top 5px
    left 5px
    right 5px
    bottom 10px
    z-index 999
    pointer-events none
    &.is-code
      .Frame__bar.is-top
        right 0px
      .Frame__bar.is-right
        top 0px
    &.is-map
      bottom 60px
    &.is-share_selfie
      bottom 80px
      .Frame__bar.is-top
        right 30px
        left 0px
      .Frame__bar.is-left
        top 0px
    &.is-share_marker
      bottom 80px
      .Frame__bar.is-top
        right 0px
        left 0px
      .Frame__bar.is-left
      .Frame__bar.is-right
        top 0px
    &.is-map
    &.is-lang
      .Frame__bar.is-top
        right 0px
      .Frame__bar.is-right
        top 0px
    &.is-capture
      .Frame__bar.is-top
      .Frame__bar.is-bottom
        right 0px
      .Frame__bar.is-right
        top 0px
        bottom 0px

  &__top-left
    position absolute
    width 17px
    height 17px
    left 0px
    top 0px
    padding 20px

  &__bottom-right
    position absolute
    width 30px
    height 26px
    right 18px
    bottom 25px

  &__top-right
    position absolute
    width 20px
    height 20px
    top 20px
    right 20px
    text-transform uppercase
    line-height 30px
    text-align center
    svg
      fill white
      width 14px
      height 14px

  &__mosaic
    position absolute
    width 30px
    &.is-top-left
      top 0px
      left 0px
    &.is-top-right
      top 0px
      right 0px
      transform scaleX(-1)
    &.is-bottom-left
      bottom 0px
      left 0px
      transform scaleY(-1)
    &.is-bottom-right
      bottom 0px
      right 0px
      transform scale(-1, -1)
    &-box
      border 1px solid gold
      width 15px
      height 15px
      float left
      box-sizing border-box
      &.is-top-right
        border-top none
        border-left none
      &.is-bottom-left
        border-left none
        border-top none

  &__bar
    background-color gold
    position absolute
    &.is-vertical
      width 1px
      top 30px
      bottom 30px
      &.is-left
        left 0px
      &.is-right
        right 0px
    &.is-horizontal
      height 1px
      left 30px
      right 30px
      &.is-top
        top 0px
      &.is-bottom
        bottom 0px

</style>
